export const dateValidation = (val: string) => {
  const re = /^(\d+)-(\d+)-(\d+)[T\s]?(\d+):(\d+):(\d+)(?:\.\d+)?Z?$/i;

  return !!re.exec(val);
};

export const emailValidation = (val: string) => {
  const re =
    /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z](?:[a-z]*[a-z])?$/;

  return !!re.exec(val);
};
